import React from "react";
import { pathHex } from "./lib/colorScales";

// A path's own colour, in whichever of the four columns the scale reads. The
// King column is the fallback because it is the one every path has and the one
// the Minutum Mundum draws.
export function pathColor(path, scale) {
  return pathHex(path, scale);
}

// One of the paths. Rendered before the spheres because SVG has no z-index —
// paint order is document order.
export default function PathLine({
  path,
  scale,
  isSelected,
  dimmed,
  inSequence = false,
  isSequenceCurrent = false,
  sequenceColour = null,
  tabIndex,
  onSelect,
  onKeyDown,
  nodeRef
}) {
  const { slug, number, letterName, x1, y1, x2, y2 } = path;
  const color = pathColor(path, scale);

  const className = [
    "path",
    isSelected ? "path--selected" : "",
    dimmed ? "path--dimmed" : "",
    // The eight paths the Lightning Flash actually runs along, lifted back out
    // of the muted network so you can see which they are.
    inSequence ? "path--in-sequence" : "",
    isSequenceCurrent ? "path--sequence-current" : ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <g
      ref={nodeRef}
      className={className}
      role="button"
      tabIndex={tabIndex}
      aria-pressed={isSelected}
      aria-label={`Path ${number}, ${letterName}. ${path.fromName} to ${path.toName}.`}
      data-testid={`path-${number}`}
      data-slug={slug}
      onClick={(event) => {
        event.stopPropagation();
        onSelect();
      }}
      onKeyDown={onKeyDown}
    >
      {/* A 1.6-unit line is untappable. `transparent` is hit-testable;
          `none` is not. */}
      <line
        className="path__hit"
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke="transparent"
        strokeWidth={6}
      />

      <line className="path__line" x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} />

      {inSequence && (
        <line
          className="path__sequence-glow"
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke={color}
          data-testid={`sequence-path-${slug}`}
        />
      )}

    </g>
  );
}
